export const PROCESS_PAYROLL_EMPLOYEE_LIST_REQUEST = "EMPLOYEE_PAYROLL_LIST_REQUEST"; 
export const PROCESS_PAYROLL_EMPLOYEE_LIST_SUCCESS = "EMPLOYEE_PAYROLL_LIST_REQUEST_SUCCESS";
export const PROCESS_PAYROLL_REQUEST = "PROCESS_PAYROLL_REQUEST";

export const READ_PROCESS_PAYROLL_EMPLOYEE = 43000;
export const PROCESS_PAYROLL = 30010;